import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { InternationalRate } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class InternationalRateApi {
    public static getInternationalRate(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<InternationalRate[]> {
        return http.get('/lookup/internationalroamingrates', {
            headers: buildHeaders(params && params.mnoCode ? {
                apiChannel: ApiChannel.PCAT,
                'X-MNO-Code': params.mnoCode
            } : {
                apiChannel: ApiChannel.PCAT
            })
        }).pipe(
            map((response: InternationalRate[]) => response.map((rate: InternationalRate) => InternationalRate.create<InternationalRate>(rate)))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_INTERNATIONAL_RATES] = InternationalRateApi.getInternationalRate;
